// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/inventory/bill-of-materials',
        component: () =>
            import('@/pages/[organisation]/inventory/bill-of-materials.vue'),
        name: 'inventory.bill-of-materials.search-bill-of-materials',
        meta: {
            loginRequired: true,
            permission: 'access.manufacturing.bill-of-materials.view-bill-of-materials',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/inventory/bill-of-materials/new.vue'),
                name: 'inventory.bill-of-materials.create-bill-of-material',
                meta: {
                    loginRequired: true,
                    permission: 'access.manufacturing.bill-of-materials.create-bill-of-material',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/inventory/bill-of-materials/[id].vue'),
                name: 'inventory.bill-of-materials.view-bill-of-material',
                meta: {
                    loginRequired: true,
                    permission: 'access.manufacturing.bill-of-materials.view-bill-of-materials',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import('@/pages/[organisation]/inventory/bill-of-materials/[id]/edit.vue'),
                name: 'inventory.bill-of-materials.update-bill-of-material',
                meta: {
                    loginRequired: true,
                    permission: 'access.manufacturing.bill-of-materials.update-bill-of-material',
                },
            },
        ],
    },
];
